import { AbstractIcon } from "./abstract";
import { componentsRegistryService } from "cruzo";

/** IBM Carbon Design System — quotes icon (32px artboard). */
export const CARBON_QUOTES_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true"><path d="M12,15H6.11A9,9,0,0,1,10,8.86l1.79-1.2L10.69,6,8.9,7.2A11,11,0,0,0,4,16.35V23a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V17A2,2,0,0,0,12,15Z"/><path d="M26,15H20.11A9,9,0,0,1,24,8.86l1.79-1.2L24.7,6,22.9,7.2A11,11,0,0,0,18,16.35V23a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V17A2,2,0,0,0,26,15Z"/></svg>`;

export class CarbonQuotesIcon extends AbstractIcon {
  static selector = "carbon-quotes-icon";

  getHTML() {
    return CARBON_QUOTES_SVG;
  }
}

componentsRegistryService.define(CarbonQuotesIcon);
